export default __webpack_public_path__ + "static/blob4-6f7be87243cc4a61f6a4fbf82ee96555.svg";